export default __webpack_public_path__ + "static/media/back.9d1ac83f.svg";